$(document).on('ready turbolinks:load', function() {
  initSelect2();
});

export function initSelect2() {
  $('.select2-container').remove()
  $('.oc-select').select2({
    allowClear: false,
    width: null
  });
}
